/*
 * @创建文件时间: 2019-12-07 13:55:06
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-27 09:53:26
 * @联系Qq:1638245306
 * @文件介绍: 
 */
export default [{
    path: 'routeStatistics',
    name: 'routeStatistics',
    meta: {
        title: '路线统计',
        auth: true
    },
    component: () =>
        import ('@/views/echarts/basicDataStatistics/routeStatistics') 
}, {
    path: 'bridgeStatistics',
    name: 'bridgeStatistics',
    meta: {
        title: '桥梁统计',
        auth: true
    },
    component: () =>
        import ('@/views/echarts/basicDataStatistics/bridgeStatistics')
},{
    path: 'tunnelStatistics',
    name: 'tunnelStatistics',
    meta: {
        title: '隧道统计',
        auth: true
    },
    component: () =>
        import ('@/views/echarts/basicDataStatistics/tunnelStatistics') 
},{
    path: 'culvertStatistics',
    name: 'culvertStatistics',
    meta: {
        title: '涵洞统计',
        auth: true
    },
    component: () =>
        import ('@/views/echarts/basicDataStatistics/culvertStatistics') 
},{
    path: 'routeNetwork',
    name: 'routeNetwork',
    meta: {
        title: '路网统计',
        auth: true
    },
    component: () =>
        import ('@/views/echarts/basicDataStatistics/routeNetwork')
}, {
    path: 'testData',
    name: 'testData',
    meta: {
        title: '检测数据统计',
        auth: true
    },
    component: () =>
        import ('@/views/echarts/mqi/testData')
}, {
    path: 'equivalentAxleLoad',
    name: 'equivalentAxleLoad',
    meta: {
        title: '年累计当量轴载统计',
        auth: true
    },
    component: () =>
        import ('@/views/echarts/mqi/equivalentAxleLoad')
}, {
    path: 'traffic',
    name: 'traffic',
    meta: {
        title: '交通量统计',
        auth: true
    },
    component: () =>
        import ('@/views/echarts/mqi/traffic')
}, {
    path: 'dailyMaintenance',
    name: 'dailyMaintenance',
    meta: {
        title: '养护维修月报表',
        auth: true
    },
    component: () =>
        import ('@/views/echarts/dailyMaintenance')
}, {
    path: 'specialProjects',
    name: 'specialProjects',
    meta: {
        title: '专项工程统计',
        auth: true
    },
    component: () =>
        import ('@/views/echarts/specialProjects')
}, {
    path: 'structure',
    name: 'structure',
    meta: {
        title: '构造物统计',
        auth: true
    },
    component: () =>
        import ('@/views/echarts/structure')
}, {
    path: 'maintainMonthCollect',
    name: 'maintainMonthCollect',
    meta: {
        title: '维修月报表汇总',
        auth: true
    },
    component: () =>
        import ('@/views/echarts/maintainMonthCollect')
}]